import _ from "lodash";
import {getSSID, isNumeric} from "@/js/utils";
import {h} from "vue";
import {JsonTreeView} from "json-tree-view-vue3";
import EventBus from '@/js/event-bus';
import { } from "@/js/extensions/string";
import {v4 as uuid} from "uuid";
import {MapSettingsRegistry} from "../Map/registry";

let ssid = getSSID();

export const documentComponentTypes = [
  {
    title: "Global",
    properties: {
      icon: '<i class="fa fa-globe" />',
      group: "Global components",
      formId: null,
      type: "global",
      label: "Global",
    },
  },
  {
    title: "Instance Content",
    properties: {
      icon: '<i class="fa fa-globe" />',
      group: "Global components",
      formId: null,
      type: "instanceContent",
      label: "Instance Content"
    },
    children: [{properties: {}, children: []}],
  },
  {
    title: "Input",
    properties: {
      icon: '<i class="fa fa-i-cursor" />',
      group: "Basic components",
      label: "Input",
      placeholder: "Enter text here...",
      value: "",
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      required: false,
      showLabel: true,
      inline: false,
      visibilityTriggers: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      type: "textInput",
      onDisabledRenderAsLabel: false,
    },
  },
  {
    title: "Phone",
    properties: {
      icon: '<i class="fa fa-phone" />',
      group: "Basic components",
      label: "Phone",
      placeholder: "",
      value: "",
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      required: false,
      showLabel: true,
      inline: false,
      visibilityTriggers: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      valueType: 'string', // or object
      type: "phoneInput",
    },
  },
  {
    title: "Label",
    properties: {
      icon: '<i class="fa fa-i-cursor" />',
      group: "Basic components",
      label: "Label",
      value: "",
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      required: false,
      showLabel: true,
      inline: false,
      visibilityTriggers: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      type: "labelInput",
      onDisabledRenderAsLabel: false,
    },
  },
  {
    title: "Textarea",
    properties: {
      icon: '<i class="fa fa-terminal" />',
      group: "Basic components",
      label: "Textarea",
      placeholder: "Enter text here...",
      value: "",
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      rows: 5,
      required: false,
      showLabel: true,
      inline: false,
      visibilityTriggers: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      type: "textarea",
      onDisabledRenderAsLabel: false,
    },
  },
  {
    title: "Number",
    properties: {
      icon: '<i class="fa fa-i-cursor" />',
      group: "Basic components",
      label: "Number",
      placeholder: "Enter text here...",
      value: "",
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      min: 0,
      max: null,
      step: 1,
      required: false,
      showLabel: true,
      inline: false,
      visibilityTriggers: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      type: "number",
      onDisabledRenderAsLabel: false,
      decimal: false,
    },
  },
  {
    title: "Boolean",
    properties: {
      icon: '<i class="fa fa-toggle-off" />',
      group: "Basic components",
      label: "Boolean",
      labelPosition: "left", // left or right
      value: false,
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      required: false,
      visibilityTriggers: [],
      renderAs: "radio", // checkbox or radio
      yes: "yes",
      no: "no",
      validationRules: [],
      disabledTriggers: [],
      showErrors: true,
      type: "boolean",
    },
  },
  {
    title: "Radio",
    properties: {
      icon: '<i class="fa fa-dot-circle-o" />',
      group: "Basic components",
      label: "Radio list",
      useDataSource: false,
      dataSource: {
        url: "",
        method: "get",
        requestType: "json",
        headers: [],
        params: [],
        labelField: "",
        valueField: "",
        updateTriggers: [],
        responsePath: "",
        callbacks: [],
        type: "endpoint",
        sendParamsOnly: false,
        rawBody: ''
      },
      options: [
        {label: "Option 1", value: "Option 1"},
        {label: "Option 2", value: "Option 2"},
      ],
      valueType: "id",
      value: "",
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      required: false,
      showLabel: true,
      inline: false,
      visibilityTriggers: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      renderAs: "radio",
      type: "radio",
    },
  },
  {
    title: "Checkbox list",
    properties: {
      icon: '<i class="fa fa-check-square-o" />',
      group: "Basic components",
      label: "Checkbox list",
      useDataSource: false,
      keepValue: false,
      loadOnTrigger: false,
      loadOnExisting: false,
      dataSource: {
        url: "",
        method: "get",
        requestType: "json",
        headers: [],
        params: [],
        labelField: "",
        valueField: "",
        updateTriggers: [],
        responsePath: "",
        callbacks: [],
        type: "endpoint",
        sendParamsOnly: false,
        rawBody: ''
      },
      options: [
        {label: "Option 1", value: "Option 1"},
        {label: "Option 2", value: "Option 2"},
      ],
      value: [],
      valueType: "id", // or object
      valueSchema: "",
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      required: false,
      showLabel: true,
      inline: false,
      visibilityTriggers: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      type: "checkbox",
    },
  },
  {
    title: "Nested inputs",
    properties: {
      icon: '<i class="fa fa-sitemap" />',
      group: "Basic components",
      label: "Nested inputs",
      useDataSource: true,
      dataSource: {
        url: "",
        method: "get",
        requestType: "json",
        headers: [],
        params: [],
        labelField: "",
        valueField: "",
        updateTriggers: [],
        responsePath: "",
        callbacks: [],
        type: "endpoint",
        sendParamsOnly: false,
        rawBody: ''
      },
      options: [
        {label: "Option 1", value: "Option 1"},
        {label: "Option 2", value: "Option 2"},
      ],
      value: [],
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      bindId: "",
      required: false,
      showLabel: true,
      inline: false,
      visibilityTriggers: [],
      displayColumns: 1,
      type: "nestedInputs",
    },
  },
  {
    title: "Select",
    properties: {
      icon: '<i class="fa fa-caret-square-o-down" />',
      group: "Basic components",
      label: "Select",
      multiple: false,
      useDataSource: false,
      keepValue: false,
      dataSource: {
        url: "",
        method: "get",
        requestType: "json",
        headers: [],
        params: [],
        labelField: "",
        valueField: "",
        updateTriggers: [],
        responsePath: "",
        callbacks: [],
        events: [],
        type: "endpoint",
        lazy: false,
        iterationSize: 50,
        sendParamsOnly: false,
        filterQueryFields: [],
        rawBody: ''
      },
      options: [
        {label: "Option 1", value: "Option 1"},
        {label: "Option 2", value: "Option 2"},
      ],
      value: "",
      valueType: "id", // or object
      valueSchema: "",
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      required: false,
      showLabel: true,
      inline: false,
      visibilityTriggers: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      type: "select",
      onDisabledRenderAsLabel: false,
      labelAsHtml: false,
      useFirstOptionAsInitValue: false
    },
  },
  {
    title: "Tree Select",
    properties: {
      icon: '<i class="fa fa-sitemap" />',
      group: "Basic components",
      label: "Tree Select",
      multiple: false,
      flatMode: false,
      flattenSearchResults: false,
      useDataSource: false,
      keepValue: false,
      dataSource: {
        url: "",
        method: "get",
        requestType: "json",
        headers: [],
        params: [],
        labelField: "",
        valueField: "",
        updateTriggers: [],
        responsePath: "",
        callbacks: [],
        events: [],
        type: "endpoint",
        lazy: false,
        iterationSize: 50,
        sendParamsOnly: false,
        filterQueryFields: [],
        rawBody: ''
      },
      options: [
        {label: "Option 1", value: "Option 1"},
        {label: "Option 2", value: "Option 2"},
      ],
      value: "",
      valueType: "id", // or object
      valueSchema: "",
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      required: false,
      showLabel: true,
      inline: false,
      visibilityTriggers: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      type: "treeSelect",
      onDisabledRenderAsLabel: false,
      valueConsistsOf: "ALL",
    },
  },
  {
    title: "Time",
    properties: {
      icon: '<i class="fa fa-clock-o" />',
      group: "Basic components",
      label: "Time",
      placeholder: "Choose time..",
      value: "",
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      required: false,
      showLabel: true,
      inline: false,
      visibilityTriggers: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      type: "time",
      onDisabledRenderAsLabel: false,
    },
  },
  {
    title: "Date",
    properties: {
      label: "Date",
      placeholder: "Choose date...",
      value: "",
      dateFormat: "d-m-Y",
      rawFormat: "Z",
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      required: false,
      showLabel: true,
      showTime: false,
      inline: false,
      visibilityTriggers: [],
      icon: '<i class="fa fa-calendar" />',
      group: "Basic components",
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      type: "date",
      onDisabledRenderAsLabel: false,
      defaultOnCurrent: false,
      isStartOfDay: false,
      isEndOfDay: false
    },
  },
  {
    title: "Rating",
    properties: {
      icon: '<i class="fa fa-star-half-o" />',
      group: "Basic components",
      label: "Rating",
      value: null,
      starsNumber: 5,
      allowCancel: false,
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      required: false,
      showLabel: true,
      inline: false,
      visibilityTriggers: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      type: "rating",
    },
  },
  {
    title: "Interactive",
    properties: {
      icon: '<i class="fa fa-mouse-pointer" />',
      group: "Layout components",
      style: "",
      visibilityTriggers: [],
      disabledTriggers: [],
      events: [],
      type: "interactive",
      cursorType: "auto",
      tag: "div",
      stickyToBottom: false
    },
    children: [{properties: {}, children: []}],
  },
  {
    title: "Pagination",
    properties: {
      icon: '<i class="fa fa-sort-numeric-asc" />',
      group: "Layout components",
      style: "",
      visibilityTriggers: [],
      disabledTriggers: [],
      events: [],
      type: "pagination",
      options: [
        {label: "Option 1", value: "Option 1"},
        {label: "Option 2", value: "Option 2"},
      ],
    },
  },
  {
    title: "Splitter",
    properties: {
      icon: '<i class="fa fa-columns" />',
      group: "Layout components",
      style: "",
      visibilityTriggers: [],
      disabledTriggers: [],
      events: [],
      type: "splitter",
      layout: "horizontal",
      gutterSize: 4,
    },
    children: [
      {properties: {style: ""}, children: []},
      {properties: {style: ""}, children: []},
    ],
  },
  {
    title: "Dropdown",
    properties: {
      icon: '<i class="fa fa-toggle-down" />',
      group: "Layout components",
      label: "Toggler",
      style: "",
      toggleStyle: "",
      visibilityTriggers: [],
      disabledTriggers: [],
      events: [],
      type: "dropdown",
      closeOnClick: true,
    },
    children: [
      {properties: {}, children: []},
      {properties: {}, children: []},
    ],
  },
  {
    title: "Modal",
    properties: {
      icon: '<i class="fa fa-window-maximize" />',
      group: "Layout components",
      label: "Modal",
      type: "modal",
      visibilityTriggers: []
    },
    children: [
      {properties: {}, children: []},
      {properties: {}, children: []},
      {properties: {}, children: []}
    ],
  },
  {
    title: "Accordion",
    properties: {
      icon: '<i class="fa fa-expand" />',
      group: "Layout components",
      style: "",
      visibilityTriggers: [],
      multiple: false,
      type: "accordion",
      bindTo: "",
      nestedInputsVariable: "",
    },
    children: [
      {
        properties: {
          label: "Header",
          style: "",
          headerStyle: "",
          customHeader: false,
          openByDefault: false,
        },
        children: [
          {properties: {}, children: []},
          {properties: {}, children: []},
        ],
      },
    ],
  },
  {
    title: "Grid",
    properties: {
      icon: '<i class="fa fa-table" />',
      group: "Layout components",
      class: "",
      style: "",
      visibilityTriggers: [],
      type: "grid",
    },
    children: [
      {properties: {style: "", responsiveCols: {}}, children: []},
      {properties: {style: "", responsiveCols: {}}, children: []},
      {properties: {style: "", responsiveCols: {}}, children: []},
    ], // size is 1 to max 12
  },
  {
    title: "Tab view",
    properties: {
      icon: '<i class="fa fa-columns" />',
      group: "Layout components",
      responsive: true,
      class: "",
      style: "",
      visibilityTriggers: [],
      type: "tabview",
      direction: "horizontal",
      useDataSource: false,
      dataSource: {
        url: "",
        method: "get",
        requestType: "json",
        headers: [],
        params: [],
        labelField: "",
        valueField: "",
        updateTriggers: [],
        responsePath: "",
        callbacks: [],
        type: "endpoint",
        sendParamsOnly: false,
        rawBody: ''
      },
      bindTo: "",
      nestedInputsVariable: "",
      tabVariable: "",
    },
    children: [
      {properties: {label: "Tab 1", style: "", properties: {visibilityTriggers: []}}, children: []},
      {properties: {label: "Tab 2", style: "", properties: {visibilityTriggers: []}}, children: []},
      {properties: {label: "Tab 3", style: "", properties: {visibilityTriggers: []}}, children: []},
    ],
  },
  {
    title: "Steps",
    properties: {
      icon: '<i class="fa fa-window-restore" />',
      group: "Layout components",
      responsive: true,
      class: "",
      style: "",
      visibilityTriggers: [],
      type: "steps",
      bindTo: "",
      nestedInputsVariable: "",
      stepVariable: "",
      selectableSteps: false,
      selectablePreviousSteps: false,
    },
    children: [
      {properties: {label: "Step 1", header: "Header 1", style: ""}, children: []},
      {properties: {label: "Step 2", header: "Header 2", style: ""}, children: []},
      {properties: {label: "Step 3", header: "Header 3", style: ""}, children: []},
    ],
  },
  {
    title: "Data Table",
    properties: {
      icon: '<i class="fa fa-table" />',
      group: "Layout components",
      responsive: true,
      class: "",
      style: "",
      visibilityTriggers: [],
      type: "dataTable",
      columns: [
        {
          header: "Title",
          field: "title",
        },
      ],
      rowActions: [],
      rowActionsAlignment: "center",
      events: [],
      options: [],
      useDataSource: true,
      dataSource: {
        url: "",
        method: "get",
        requestType: "json",
        headers: [],
        params: [],
        labelField: "",
        valueField: "",
        updateTriggers: [],
        responsePath: "",
        callbacks: [],
        type: "endpoint",
        sendParamsOnly: false,
        rawBody: ''
      },
      pagination: true,
      pageReportTemplate: "Page {currentPage}: {first} - {last} / {totalRecords}",
      lazy: false,
    },
  },
  {
    title: "Tree View",
    properties: {
      icon: '<i class="fa fa-sitemap" />',
      group: "Layout components",
      responsive: true,
      class: "",
      style: "",
      visibilityTriggers: [],
      disabledTriggers: [],
      type: "treeView",
      events: [],
      options: [],
      valueSchema: '',
      useDataSource: true,
      dataSource: {
        url: "",
        method: "get",
        requestType: "json",
        headers: [],
        params: [],
        labelField: "",
        valueField: "",
        updateTriggers: [],
        responsePath: "",
        callbacks: [],
        type: "endpoint",
        sendParamsOnly: false,
        rawBody: ''
      },
      stripTags: false,
      disableBranchNodes: false,
      isSortable: false,
      multiple: false,
      parentKey: 'parentDocumentId',
      childrenKey: 'children',
      labelKey: 'label',
      valueKey: 'value',
      bindTo: "",
      value: ""
    },
  },
  {
    title: "List",
    properties: {
      icon: '<i class="fa fa-list"/>',
      group: "Layout components",
      class: "",
      style: "",
      visibilityTriggers: [],
      type: "list",
      options: [],
      useDataSource: true,
      dataSource: {
        url: "",
        method: "get",
        requestType: "json",
        headers: [],
        params: [],
        labelField: "",
        valueField: "",
        updateTriggers: [],
        responsePath: "",
        callbacks: [],
        type: "endpoint",
        sendParamsOnly: false,
        rawBody: ''
      },
    },
    children: [{properties: {label: "Item", style: ""}, children: []}],
  },
  {
    title: "Simple List",
    properties: {
      icon: '<i class="fa fa-list"/>',
      group: "Layout components",
      class: "",
      style: "",
      visibilityTriggers: [],
      type: "simpleList",
      options: [],
      useDataSource: true,
      dataSource: {
        url: "",
        method: "get",
        requestType: "json",
        headers: [],
        params: [],
        labelField: "",
        valueField: "",
        updateTriggers: [],
        responsePath: "",
        callbacks: [],
        type: "endpoint",
        sendParamsOnly: false,
        rawBody: ''
      },
    },
    children: [{properties: {label: "Item", style: ""}, children: []}],
  },
  {
    title: "Recursive Children",
    properties: {
      icon: '<i class="fa fa-refresh"/>',
      group: "Layout components",
      type: "recursiveChildren",
      options: [],
      childrenKey: 'items'
    }
  },
  {
    title: "Carousel",
    properties: {
      icon: '<i class="fa fa-arrows-h"/>',
      group: "Layout components",
      class: "",
      style: "",
      visibilityTriggers: [],
      type: "carousel",
      options: [],
      useDataSource: true,
      dataSource: {
        url: "",
        method: "get",
        requestType: "json",
        headers: [],
        params: [],
        labelField: "",
        valueField: "",
        updateTriggers: [],
        responsePath: "",
        callbacks: [],
        type: "endpoint",
        sendParamsOnly: false,
        rawBody: ''
      },
      numVisible: 3,
      numScroll: 1,
      autoplayInterval: 3000,
      showNavigators: true,
      showIndicators: true,
      page: 0, //Index of the first item.
      verticalViewPortHeight: "300px",
      orientation: "horizontal",
      circular: false,
      responsiveOptions: [
        {
          breakpoint: "1400px",
          numVisible: 2,
          numScroll: 1,
        },
        {
          breakpoint: "1199px",
          numVisible: 3,
          numScroll: 1,
        },
        {
          breakpoint: "767px",
          numVisible: 2,
          numScroll: 1,
        },
        {
          breakpoint: "575px",
          numVisible: 1,
          numScroll: 1,
        },
      ],
    },
    children: [{properties: {label: "Item", style: ""}, children: []}],
  },
  {
    title: "Card",
    properties: {
      icon: '<i class="fa fa-square-o"/>',
      group: "Layout components",
      class: "",
      style: "overflow: hidden",
      visibilityTriggers: [],
      type: "card",
      bindTo: "",
      nestedInputsVariable: "",
    },
    children: [
      {properties: {label: "Header", style: "padding: 1rem"}, children: []},
      {properties: {label: "Content", style: ""}, children: []},
      {properties: {label: "Footer", style: ""}, children: []},
    ],
  },
  {
    title: "Image",
    properties: {
      icon: '<i class="fa fa-image" />',
      group: "Layout components",
      label: "Image",
      value: "",
      class: "",
      style: "",
      imageStyle: "",
      enablePreview: false,
      hint: "",
      bindTo: "",
      required: false,
      responsive: true,
      useAsInput: false,
      inline: false,
      visibilityTriggers: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      type: "image",
    },
  },
  {
    title: "File",
    properties: {
      icon: '<i class="fa fa-file-o" />',
      group: "Layout components",
      label: "File",
      value: [],
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      required: false,
      useAsInput: true,
      isMulti: true,
      inline: false,
      visibilityTriggers: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      maxNumberOfFiles: 0,
      maxFileSize: 5,
      type: "file",
      valueType: "url", // or object
      valueSchema: "",
      isLottieFile: false,
      executeUpload: true,
      onlySignedFile: false
    },
  },
  {
    title: "Text",
    properties: {
      icon: '<i class="fa fa-header" />',
      group: "Basic components",
      tag: "p",
      value: "Write here...",
      class: "",
      style: "",
      visibilityTriggers: [],
      type: "text",
      fields: [],
    },
  },
  {
    title: "Editor",
    properties: {
      icon: '<i class="fa fa-file-text-o" />',
      group: "Basic components",
      label: "Editor",
      value: "",
      class: "",
      style: "",
      bindTo: "",
      hint: "",
      visibilityTriggers: [],
      required: false,
      useAsInput: false,
      showLabel: true,
      interpolate: false,
      variables: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      type: "editor",
    },
  },
  {
    title: "Code Editor",
    properties: {
      icon: '<i class="fa fa-code" />',
      group: "Basic components",
      label: "Code Editor",
      value: "",
      class: "",
      style: "",
      hint: "",
      bindTo: "",
      rows: 5,
      showLabel: true,
      visibilityTriggers: [],
      disabledTriggers: [],
      validationRules: [],
      showErrors: true,
      showMaximize: true,
      language: 'text',
      type: "codeEditor"
    },
  },
  {
    title: "Button",
    properties: {
      icon: '<i class="fa fa-hand-pointer-o" />',
      group: "Basic components",
      label: "Button",
      class: "",
      style: "",
      displayIcon: "",
      visibilityTriggers: [],
      disabledTriggers: [],
      events: [],
      type: "button",
      size: undefined,
      layout: {
        raised: false,
        rounded: false,
        outlined: false
      },
      buttonId: ''
    },
  },
  {
    title: "App",
    properties: {
      icon: '<i class="fa fa-cube" />',
      group: "Layout components",
      label: "iFrame App",
      value: "",
      class: "",
      style: "",
      visibilityTriggers: [],
      variables: [],
      events: [],
      showLabel: true,
      type: "app",
    },
  },
  {
    title: "Flow Buttons",
    properties: {
      icon: '<i class="fa fa-hand-pointer-o" />',
      group: "Flow components",
      label: "Flow Buttons",
      description: "Flow Buttons",
      visibilityTriggers: [],
      type: "flowButtons",
    },
  },
  {
    title: "Flow Row Actions",
    properties: {
      icon: '<i class="fa fa-hand-pointer-o" />',
      group: "Flow components",
      label: "Flow Row Actions",
      description: "Flow Row Actions",
      visibilityTriggers: [],
      type: "flowRowActions",
      slotProps: '(() => {\n\treturn {\n\t\tdata: this.data\n\t};\n})()'
    },
  },
  {
    title: "Alert",
    properties: {
      icon: '<i class="fa fa-warning" />',
      displayIcon: "",
      group: "Feedback components",
      label: "Alert",
      description: "Alert",
      severity: "warn",
      class: "",
      style: "",
      visibilityTriggers: [],
      closeable: true,
      type: "alert",
    },
  },
  {
    title: "Toast Template",
    properties: {
      icon: '<i class="fa fa-comment" />',
      group: "Feedback components",
      label: "Toast Template",
      description: "Toast Template",
      position: "top-right",
      severity: "info",
      life: 5000,
      toastGroup: "default",
      class: "",
      style: "",
      visibilityTriggers: [],
      type: "toastTemplate",
      toastId: 'defaultToastTemplateId',
    },
    children: [{properties: {}, children: []}],
  },
  {
    title: "Map",
    properties: {
      icon: '<i class="fa fa-map" />',
      group: "Layout components",
      label: "Map",
      value: "",
      class: "",
      visibilityTriggers: [],
      variables: [],
      showLabel: true,
      type: "map",

      // these are map properties like the iframe
      style: null,
      settings: {
        showMenu: false,
        darkMode: false,
        showSearchOnMap: false,
        showResultingGeometries: false,
        infoButtonActive: true,
        mapModes: [],
        defaultMapMode: null,
        emitEvents: false,
        emitEventsList: [],
      },
      organizationId: null,
      visibleLayers: [],
      queryLayers: [],
      metadataFilter: [],
      alterLayers: [],
      customButtons: {},
      customControls: {},
    },
  },
  {
    title: "Map legend",
    properties: {
      icon: '<i class="fa fa-map" />',
      group: "Layout components",
      label: "Map legend",
      value: "",
      class: "",
      visibilityTriggers: [],
      variables: [],
      showLabel: true,
      type: "mapLegend",
      style: null
    },
  },
  {
    title: "Chart",
    properties: {
      icon: '<i class="fa fa-bar-chart"/>',
      group: "Data visualization",
      label: "Chart",
      showLabel: true,
      showLegend: true,
      showTooltip: true,
      description: "",
      class: "",
      style: "",
      visibilityTriggers: [],
      disabledTriggers: [],
      type: "chart",
      palette: "Material",
      options: [],
      mappingMethod: "(el) => ({\n\ttitle: el.title,\n\tvalue: el.value\n})",
      series: [{title: "Series 1", chartType: "line", argumentField: "title", valueField: "value"}],
      useDataSource: true,
      dataSource: {
        url: "",
        method: "get",
        requestType: "json",
        headers: [],
        params: [],
        labelField: "",
        valueField: "",
        updateTriggers: [],
        responsePath: "",
        callbacks: [],
        type: "endpoint",
        sendParamsOnly: false,
        rawBody: ''
      },
    },
  },
  {
    title: "Pie Chart",
    properties: {
      icon: '<i class="fa fa-pie-chart"/>',
      group: "Data visualization",
      label: "Pie chart",
      showLabel: true,
      showLegend: true,
      showTooltip: true,
      description: "",
      class: "",
      style: "",
      visibilityTriggers: [],
      disabledTriggers: [],
      type: "pieChart",
      palette: "Material",
      chartType: "pie",
      startAngle: 0,
      options: [],
      mappingMethod: "(el) => ({\n\ttitle: el.title,\n\tvalue: el.value\n})",
      useDataSource: true,
      dataSource: {
        url: "",
        method: "get",
        requestType: "json",
        headers: [],
        params: [],
        labelField: "",
        valueField: "",
        updateTriggers: [],
        responsePath: "",
        callbacks: [],
        type: "endpoint",
        sendParamsOnly: false,
        rawBody: ''
      },
    },
  },
  {
    title: "Kanban",
    properties: {
      icon: '<i class="fa fa-columns"/>',
      group: "Layout components",
      class: "",
      style: "display: flex;\ngap: .5rem;\nmax-width: 100%;\noverflow-x: scroll;",
      itemContainerStyle: "",
      computedStyle: "(() => {\n\treturn `\n\t\tbackground-color: var(--surface-50);\n\t\tpadding: .5rem;\n\t\tmin-width: 150px;\n\t`\n})()",
      computedItemStyle: "",
      visibilityTriggers: [],
      type: "kanban",
      codeKey: "code",
      columnCodeKey: "code",
      groupKey: "group",
      columnGroupKey: "colGroup",
      ghostClass: "opacity-50",
      columnGhostClass: "opacity-50",
      disableMove: false,
      disableColumnMove: false,
      itemsKey: "items",
      bindTo: "",
      events: []
    },
    children: [
      {properties: {label: "Column", style: ""}, children: []},
      {properties: {label: "Item", style: ""}, children: []}
    ]
  },
  {
    title: "Kanban items",
    properties: {
      icon: '<i class="fa fa-list-alt"/>',
      group: "Layout components",
      type: "kanbanItems"
    }
  },
  {
    title: "Gantt",
    properties: {
      icon: '<i class="fa fa-align-left"/>',
      group: "Data visualization",
      label: "Gantt",
      description: "",
      class: "",
      style: "",
      visibilityTriggers: [],
      disabledTriggers: [],
      type: "gantt",
      scaleType: 'auto',
      ganttHeight: '500px',
      taskListWidth: '500px',
      toolbarProperties: {
        undo: true,
        redo: true,
        collapseAll: true,
        expandAll: true,
        addTask: false,
        deleteTask: false,
        zoomIn: true,
        zoomOut: true,
      },
      columns: [
        {
          header: "Title",
          field: "title",
        },
      ],
      taskProperties: {
        variable: '',
        keyExpr: 'id',
        parentIdExpr: 'parentId',
        titleExpr: 'title',
        progressExpr: 'progress',
        colorExpr: 'color',
        startExpr: 'start',
        endExpr: 'end',
        mappingMethod: "(el) => ({\n\tid: el.documentId,\n\ttitle: el.title,\n\tparentId: el.parentDocumentId,\n\tprogress: el.progress,\n\tcolor: el.color,\n\tstart: el.startDate,\n\tend: el.endDate\n})",
      },
      resourceProperties: {
        variable: '',
        keyExpr: 'id',
        textExpr: 'text',
        colorExpr: 'color',
        mappingMethod: "(el) => ({\n\tid: el.documentId,\n\ttext: el.title,\n\tcolor: el.color\n})",
      },
      resourceAssignmentsProperties: {
        variable: '',
        keyExpr: 'id',
        resourceIdExpr: 'resourceId',
        taskIdExpr: 'taskId',
        mappingMethod: "(el) => ({\n\tid: el.documentId,\n\tresourceId: el.documentDetailId,\n\ttaskId: el.documentId\n})",
      },
      dependencyProperties: {
        variable: '',
        keyExpr: 'id',
        typeExpr: 'type',
        predecessorIdExpr: 'predecessorId',
        successorIdExpr: 'successorId',
        mappingMethod: "(el) => ({\n\tid: el.documentId,\n\ttype: el.type,\n\tpredecessorId: el.documentParentId,\n\tsuccessorId: el.documentParentId\n})",
      }
    },
  },
  {
    title: "QrCode",
    properties: {
      icon: '<i class="fa fa-qrcode"/>',
      group: "Data visualization",
      label: "QR Code",
      description: "QR Code",
      type: "qrCode",
      bindTo: "",
      size: 100
    },
  },
  {
    title: "Fields",
    properties: {
      icon: '<i class="fa fa-list"/>',
      group: "Layout components",
      label: "Nomenclature Fields",
      description: "Nomenclature Fields",
      type: "nomenclatureFields"
    },
    children: [{properties: [], children: []}]
  },
  {
    title: "Calendar",
    properties: {
      icon: '<i class="fa fa-calendar"/>',
      group: "Data visualization",
      label: "Calendar",
      description: "Calendar",
      type: "calendar",
      bindTo: "",
      time: true,
      todayButton: true,
      activeView: "month"
    },
    children: [
      {properties: {}, children: []},
      {properties: {}, children: []}
    ]
  },
  {
    title: "Picture editor",
    properties: {
      icon: '<i class="fa fa-picture-o" />',
      group: "Layout components",
      style: "",
      visibilityTriggers: [],
      multiple: false,
      type: "pictureEditor",
      bindTo: "",
      nestedInputsVariable: "",
    },
    children: [],
  },
  {
    title: 'Video stream',
    properties: {
      icon: '<i class="fa fa-video"/>',
      group: 'Layout components',
      style: '',
      visibilityTriggers: [],
      type: 'videoStream',
      documentIdBindTo: '',
      documentDetailIdBindTo: '',
      flvBindTo: '',
      flvValue: false,
      label: 'video',
      showLabel: true
    }
  },
];

export const fieldTypeToComponentTypeProperties = {
  'string': {
    type: 'textInput'
  },
  'editor': {
    type: 'editor',
    useAsInput: true
  },
  'integer': {
    type: 'number'
  },
  'decimal': {
    type: 'number',
    decimal: true
  },
  'date': {
    type: 'date'
  },
  'time': {
    type: 'time'
  },
  'boolean': {
    type: 'boolean'
  },
  'photo': {
    type: 'file'
  },
  'file': {
    type: 'file'
  }
};

export const buttonClasses = [
  {label: "Primary", value: "p-button-primary"},
  {label: "Secondary", value: "p-button-secondary"},
  {label: "Success", value: "p-button-success"},
  {label: "Info", value: "p-button-info"},
  {label: "Warning", value: "p-button-warning"},
  {label: "Danger", value: "p-button-danger"},
  {label: "Text", value: "p-button-text"},
];

export const alertClasses = [
  {label: "Success", value: "success"},
  {label: "Info", value: "info"},
  {label: "Warn", value: "warn"},
  {label: "Error", value: "error"},
];

export function getTemplateVariable(name) {
  return /\${([^{}]*)}/gm.test(name) ? String(name).replace(/\${([^{}]*)}/gm, "$1") : name;
}

export function isTemplateVariable(name) {
  return /\${([^{}]*)}/gm.test(name);
}

/**
 * @param app
 * @param path
 * @param value
 * @param extraData
 * @param forceToObject
 * @returns {{}|any}
 */
export function objectVariable(app, path, value = undefined, extraData = undefined, forceToObject = false) {
  let object = app || {};
  if (/^formInstance./.test(path) && object.formInstance) {
    object = object.formInstance;
  } else if (!/^(data|\$\{data|extraData|\$\{extraData|auxData|\$\{auxData)\./.test(path) && object.data) {
    object = object.data;
  }

  path = getTemplateVariable(path);
  const pathVariables = findVariablesInString(path);
  if (pathVariables.length && object) {
    for (let item of pathVariables) {
      path = path.replace(
        item,
        objectVariable({...object, ...(extraData || {})}, item, undefined, extraData, forceToObject)
      );
    }
  }
  if (typeof value !== "undefined") {
    return forceToObject ? _.setWith(object, path, value, Object) : _.set(object, path, value);
  } else {
    let result = _.get(object, path);
    if (result === undefined && extraData) result = _.get({extraData}, path);
    return result;
  }
}

/**
 * Extract ${variable}s from string
 * @param value
 * @returns {*[]}
 */
export function findVariablesInString(value) {
  const regex = /\$\{(\w+)\}/g;
  let m;
  let vars = [];
  while ((m = regex.exec(value)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }

    // The result can be accessed through the `m`-variable.
    m.forEach((match, groupIndex) => {
      if (groupIndex === 0 && vars.indexOf(match) === -1) {
        vars.push(match);
      }
    });
  }
  return vars;
}

/**
 *
 * @param arr
 * @param newFill // creates a new property
 * @param fillFrom // property used to fill newFill
 * @param fillDefault // default static value for the newFill
 * @param clearValues // array of properties that should be removed
 * @param keepValues // array of properties that should be kept
 * @param useInterpolationFor // null|array of properties where interpolation must be applied
 * @param forceRefill
 * @returns {*}
 */
export function arrayMapRecursive(
  arr,
  newFill,
  fillFrom,
  fillDefault,
  clearValues,
  keepValues,
  useInterpolationFor,
  forceRefill
) {
  if (Array.isArray(arr)) {
    for (let x = 0; x < arr.length; x++) {
      if (!arr[x][newFill] || forceRefill) {
        arr[x][newFill] = fillFrom
          ? isTemplateVariable(fillFrom)
            ? String(fillFrom).interpolateObject(arr[x])
            : arr[x][fillFrom]
          : fillDefault
            ? fillDefault === "random"
              ? Math.floor(Math.random() * 100000000) + 1
              : fillDefault
            : "";
      }

      if (useInterpolationFor) {
        for (let field of useInterpolationFor) {
          if (arr[x][field] && isTemplateVariable(arr[x][field])) {
            arr[x][field] = String(arr[x][field]).interpolateObject(arr[x]);
          }
        }
      }

      if (clearValues && clearValues.length) {
        for (let cv of clearValues) {
          delete arr[x][cv];
        }
      }
      if (keepValues && keepValues.length) {
        const filtered = {};
        for (let cv of keepValues) {
          if (/\./.test(cv)) {
            objectVariable(filtered, objectVariable(arr[x], cv));
          } else {
            filtered[cv] = arr[x][cv];
          }
        }
        arr[x] = filtered;
      }

      if (arr[x].children) {
        arrayMapRecursive(
          arr[x].children,
          newFill,
          fillFrom,
          fillDefault,
          clearValues,
          keepValues,
          useInterpolationFor,
          forceRefill
        );
      }
      if (arr[x]?.properties?.fields) {
        arrayMapRecursive(
          arr[x].properties.fields,
          newFill,
          fillFrom,
          fillDefault,
          clearValues,
          keepValues,
          useInterpolationFor,
          forceRefill
        );
      }
    }
  }
  return arr;
}

/**
 * Check if element is a button which will call an endpoint
 * @param element
 * @returns {boolean}
 */
export function isButtonWithDataSource(element) {
  if (!element || element.properties.type !== 'button') return false;
  return !!element?.properties?.events?.find(ev => ev.event.value === 'click' && ev.action.code === 'endpointCall')
}

export function checkDataSource(
  app,
  element,
  trigger = null,
  extraData,
  stopOnInvalidData = false,
  auxData = null,
  formInstance = null,
  formElement = null
) {
  if (stopOnInvalidData && !app.isGlobalValid) {
    return;
  }

  let optionSchema = false;
  if (element?.properties?.valueType === "object") {
    optionSchema =
      element?.properties?.valueSchema &&
        Array.isArray(element?.properties?.valueSchema) &&
        element?.properties?.valueSchema.length
        ? element?.properties?.valueSchema
        : true;
  }

  if (
    element?.properties?.useDataSource &&
    element?.properties?.dataSource?.url &&
    (!element?.properties?.dataSource?.type || element?.properties?.dataSource?.type === "endpoint") &&
    (!element?.properties?.loadOnTrigger ||
      (element?.properties?.loadOnExisting && app?.data?.documentId) ||
      (trigger && _.get(app.data, trigger)))
  ) {
    if (trigger && element?.properties?.bindTo && !element?.properties?.keepValue) {
      objectVariable(app, element.properties.bindTo, element.properties.multiple ? [] : "");
    }
    let params = getComputedParams(app, element, auxData, extraData);
    if (extraData && typeof extraData === "object" && !element.properties.dataSource?.sendParamsOnly && element?.properties?.dataSource?.method !== 'get') {
      params = {
        ...extraData,
        ...params,
      };
    }
    if (element.fromSelect && element.properties.dataSource?.lazy) {
      params = {
        take: element.selectOptions.size,
        skip: element.selectOptions.iteration * element.selectOptions.size,
        filter: element.selectOptions.filter,
        query: element.selectOptions.query || null,
        ...params,
      };
    }

    if (element.fromDataTable || element.properties?.lazy) {
      const pagerOptions = localStorage.getItem('pagerOptions_' + element.documentDetailId);
      if (pagerOptions) {
        const cachedOptions = JSON.parse(pagerOptions);
        if (!element.pagerOptions) element.pagerOptions = {};
        if (cachedOptions.take) {
          element.pagerOptions.take = cachedOptions.take;
        }
      }

      params = {
        ...params,
        take: element?.pagerOptions?.take || 10,
        skip: element?.pagerOptions?.skip || 0,
        orderBy:
          element?.pagerOptions?.sortField && !isTemplateVariable(element?.pagerOptions?.sortField)
            ? `${element?.pagerOptions?.sortField} ${element?.pagerOptions?.sortOrder}` :
            params.orderBy ? params.orderBy : null,
      }

      // save the applied values
      localStorage.setItem('pagerOptions_' + element.documentDetailId, JSON.stringify({
        take: params.take,
        skip: params.skip,
        sortField: element?.pagerOptions?.sortField,
        sortOrder: element?.pagerOptions?.sortOrder,
      }));
    }

    delete params.reload;
    app.isLoading = true;
    if (element.properties.dataSource?.globalLoading) {
      app.$emit("action", "loading", app.isLoading);
    }
    if (app.isEditMode) {
      app.isLoading = false;
      if (element.properties.dataSource?.globalLoading) {
        app.$emit("action", "loading", app.isLoading);
      }
    } else if (app.isLocalEdit) {
      app.$dialog.open(
        h("div", [
          h("div", {class: "flex justify-content-between"}, [
            h("strong", {class: "mr-3"}, `${app.$t("url")}:`),
            h("span", element?.properties?.dataSource?.url),
          ]),
          h("div", {class: "flex justify-content-between"}, [
            h("strong", {class: "mr-3"}, `${app.$t("method")}:`),
            h("span", element?.properties?.dataSource?.method),
          ]),
          h("strong", app.$t("headers")),
          h(JsonTreeView, {
            data: JSON.stringify(element?.properties?.dataSource?.headers),
            colorScheme: document.querySelector("html").classList.contains("dark") ? "dark" : "light",
          }),
          h("strong", app.$t("params")),
          h(JsonTreeView, {
            data: JSON.stringify(params),
            colorScheme: document.querySelector("html").classList.contains("dark") ? "dark" : "light",
          }),
        ]),
        {
          props: {
            position: "bottomright",
            header: app.$t("Data source test"),
          },
        }
      );
      app.isLoading = false;
      if (element.properties.dataSource?.globalLoading) {
        app.$emit("action", "loading", app.isLoading);
      }
    } else {
      if (isButtonWithDataSource(formElement)) formElement.properties.isDisabled = true;
      app.$store
        .dispatch("dataSourceCall", {
          method: element?.properties?.dataSource?.method,
          requestType: element?.properties?.dataSource?.requestType,
          headers: getDataSourceHeaders(element?.properties?.dataSource?.headers, app),
          url: String(element?.properties?.dataSource?.url).interpolateObject(app),
          params: params,
          query: {
            moduleId: app.moduleId || app.module,
          },
          body: element?.properties?.dataSource?.rawBody ? getDataSourceBody(element?.properties?.dataSource?.rawBody, app) : null
        })
        .then((response) => {
          if (isButtonWithDataSource(formElement)) formElement.properties.isDisabled = false;

          const lazyLoaded = (element.fromSelect || element.fromDataTable) && element.properties.options && element.properties.dataSource?.lazy;
          let responseData = element?.properties?.dataSource?.responsePath
            ? objectVariable(response, element?.properties?.dataSource?.responsePath)
            : response;
          if (
            !lazyLoaded ||
            element?.selectOptions?.reset
          ) {
            element.properties.options = [];
            app.isLoading = false;
          }

          if (Array.isArray(responseData)) {
            if (element.properties?.dataSource?.labelField && element.properties?.dataSource?.valueField) {
              const auxOptions = getElementOptions(
                responseData,
                element.properties?.dataSource?.labelField,
                element.properties?.dataSource?.valueField,
                optionSchema
              );
              if (lazyLoaded) element.properties.options.push(...auxOptions);
              else element.properties.options = auxOptions;
              app.isLoading = false;
            } else {
              if (lazyLoaded) element.properties.options.push(...responseData);
              else element.properties.options = responseData;
              app.isLoading = false;
            }
          } else if (responseData) {
            if (element.properties?.dataSource?.labelField && element.properties?.dataSource?.valueField) {
              const auxOptions = getElementOptions(
                responseData,
                element.properties?.dataSource?.labelField,
                element.properties?.dataSource?.valueField,
                optionSchema
              );
              if (lazyLoaded) element.properties.options.push(...auxOptions);
              else element.properties.options = auxOptions;
              app.isLoading = false;
            } else {
              if (lazyLoaded) element.properties.options.push(...responseData);
              else element.properties.options = responseData;
              app.isLoading = false;
            }
          }
          // run callbacks
          if (element.properties?.dataSource?.callbacks && element.properties.dataSource.callbacks.length) {
            executeActions(
              app,
              element.properties.dataSource.callbacks,
              {data: responseData, parentData: extraData},
              element,
              undefined,
              formInstance
            )
              .then()
              .catch();
          }
          app.isLoading = false;
          if (element.properties.dataSource?.globalLoading) {
            app.$emit("action", "loading", app.isLoading);
          }
        })
        .catch((error) => {
          app.isLoading = false;
          if (isButtonWithDataSource(formElement)) formElement.properties.isDisabled = false;

          if (element.properties.dataSource?.globalLoading) {
            app.$emit("action", "loading", app.isLoading);
          }

          app.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error,
            life: 5000,
          });
        });
    }
  } else if (
    element?.properties?.useDataSource &&
    element?.properties?.dataSource?.stateVariable &&
    (!element?.properties?.dataSource?.type || element?.properties?.dataSource?.type === "state")
  ) {
    element.properties.options = [];
    const options = JSON.parse(
      JSON.stringify(objectVariable(app.$store.state[ssid], element?.properties?.dataSource?.stateVariable))
    );
    if (options && options.length) {
      if (element.properties?.dataSource?.labelField && element.properties?.dataSource?.valueField) {
        element.properties.options = getElementOptions(
          options,
          element.properties?.dataSource?.labelField,
          element.properties?.dataSource?.valueField,
          optionSchema
        );
      } else {
        element.properties.options = options;
      }
    }
  } else if (
    element?.properties?.useDataSource &&
    element?.properties?.dataSource?.variable &&
    (!element?.properties?.dataSource?.type || element?.properties?.dataSource?.type === "variable")
  ) {
    element.properties.options = [];
    const options = objectVariable(app, element?.properties?.dataSource?.variable);
    if (options && options.length) {
      if (element.properties?.dataSource?.labelField && element.properties?.dataSource?.valueField) {
        element.properties.options = getElementOptions(
          options,
          element.properties?.dataSource?.labelField,
          element.properties?.dataSource?.valueField,
          optionSchema
        );
      } else {
        element.properties.options = options;
      }
    }
  }
}

function getDataSourceHeaders(value, app) {
  let headers = {};

  if (value && Array.isArray(value)) headers = Object.assign({}, value);
  if (value && typeof value === "string") headers = JSON.parse(value);
  if (value && typeof value === "object") headers = value;

  for (let key in headers) {
    headers[key] = headers[key].interpolateObject(app);
  }

  return headers;
}

function getDataSourceBody(value, app) {
  if (app === undefined) {
    console.log('app var is not defined');
  } // this line is here to prevent tree-shaking of the app variable
  let val = value.replace(/this(\?)?\./g, "app.").replace(/slotProps(\?)?\./g, "extraData.");
  try {
    return eval(val)
  } catch (e) {
    return val
  }
}

function getElementOptions(options, label, value, optionSchema) {
  const opts = arrayMapRecursive(options, "label", label, null, null, null, ["label"]);
  //let keepValues = ["label", "value", "properties", "children"];
  let keepValues = []
  if (optionSchema) {
    if (typeof optionSchema === "boolean") {
      keepValues = null;
    } else {
      keepValues = [...keepValues, ...optionSchema];
    }
  }
  return arrayMapRecursive(opts, "value", value, null, null, keepValues, ["label"]);
}

export function getComputedParams(app, element, auxData, extraData) {
  let params = {};
  if (element?.properties?.dataSource?.params && element.properties?.dataSource?.params.length) {
    for (let param of element.properties?.dataSource?.params?.filter(p => !p.static || p.enabled)) {
      if (param.value) {
        let val = param.value.replace(/this(\?)?\./g, "app.");
        val = val.replace(/slotProps(\?)?\./g, "extraData.");
        try {
          if (!/^\${/.test(val))
            val = eval(val);
        } catch (e) {
        }
        params[param.key] = isTemplateVariable(val) ? objectVariable(app, val, undefined, {...auxData, ...extraData}) : val;
      }
    }
  }
  return Object.keys(params) ? params : null;
}

export function mapFormDataBySchema(schema, data) {
  if (isNumeric(schema) || typeof schema === 'string') return schema
  if (!data) return null;

  let mapped = {};
  if (typeof schema === "object" && Array.isArray(schema)) {
    let result = []
    schema.forEach(s => {
      result.push(mapFormDataBySchema(s, data));
    })
    return result;
  } else
    for (let key in schema) {
      if (typeof schema[key] === "object") {
        mapped[key] = []
        if (Array.isArray(schema[key])) {
          schema[key].forEach((k, i) => {
            mapped[key].push(mapFormDataBySchema(schema[key][i], data))
          })
        } else
          mapped[key] = mapFormDataBySchema(schema[key], data);
      } else if (isTemplateVariable(schema[key])) {
        objectVariable(
          mapped,
          key,
          schema[key] === "${data}" ? data : schema[key].interpolateObject(data.data ? data : {data: data})
        );
      } else {
        objectVariable(mapped, key, schema[key]);
      }
    }
  return mapped && Object.keys(mapped).length ? mapped : null;
}

export async function executeActions(app, actions, data, element, dataToUpdate, formInstance, pdfSignerRes) {
  let hasValidate = false;
  let hasConfirm = false;
  let isConfirmed = false;
  let isValid = false;
  let executedActions = [];
  let auxVariables = [];
  let auxValView;
  //let pdfSignerRes = {};
  actions = actions.map(act => ({...act, action: {...act.action, id: _.uniqueId()}}));
  for (let event of actions) {
    if (event?.event?.value === "iFrameMessage") {
      if (event.windowMessage?.action !== event.event.iFrameAction && event.event.iFrameAction) continue;
      data.windowMessage = event.windowMessage;
    }
    if ((!hasConfirm || isConfirmed) && (!hasValidate || isValid)) {
      if (event?.properties?.rootEvent && !formInstance?.isRootDocument) {
        app.$emit("action", "rootAction", {app, actions: [event], data, element, dataToUpdate, formInstance});
      } else {
        executedActions.push(event.action.id);
        switch (event.action.code) {
          case "emit":
            if (
              event.value === "delete" &&
              element &&
              element?.properties?.dataSource?.type === "variable" &&
              data.hasOwnProperty("rowIndex") &&
              element?.properties?.options
            ) {
              if (dataToUpdate) {
                if (dataToUpdate.children) {
                  dataToUpdate.children = dataToUpdate.children.filter((el, i) => i !== data.rowIndex);
                } else {
                  dataToUpdate = dataToUpdate.filter((el, i) => i !== data.rowIndex);
                }
              } else {
                let variableData = (objectVariable(app, element?.properties?.dataSource?.variable) || []).filter(
                  (el, i) => i !== data.rowIndex
                );
                element.properties.options = variableData;
                objectVariable(app, element?.properties?.dataSource?.variable, variableData);
              }
            }

            if (event.value) {
              if (event?.properties?.onEventVariableSchema && data?.data) {
                try {
                  data.data = mapFormDataBySchema(
                    event?.properties?.onEventVariableSchemaIsScript ? eval(event?.properties?.onEventVariableSchema) : JSON.parse(event?.properties?.onEventVariableSchema),
                    dataToUpdate || data.data
                  );
                } catch (e) {
                  data.data = objectVariable(dataToUpdate || data.data, event?.properties?.onEventVariableSchema);
                }
              } else if (event?.properties?.onEventVariableSchema && data) {
                try {
                  data = mapFormDataBySchema(event?.properties?.onEventVariableSchemaIsScript ? eval(event?.properties?.onEventVariableSchema) : JSON.parse(event?.properties?.onEventVariableSchema), dataToUpdate || data);
                } catch (e) {
                  data = objectVariable(dataToUpdate || data, event?.properties?.onEventVariableSchema);
                }
              }

              if (event.value === "select" && data.hasOwnProperty("rowIndex")) delete data.rowIndex;
              if (event.value === 'custom') {
                EventBus.emit(event.valueName, {event: event, data: data});
              } else if ((event?.properties?.rootEvent && formInstance.isRootDocument) || event?.properties?.detachedEvent) {
                formInstance.onAction("emit", event.value, data);
              } else {
                app.$emit("action", "emit", event.value, data);
              }
            }
            break;
          case "stepEventEmit":
            if ((event?.properties?.rootEvent && formInstance.isRootDocument) || event?.properties?.detachedEvent) {
              formInstance.onAction("stepEventEmit", event.value);
            } else {
              app.$emit("action", "stepEventEmit", event.value);
            }
            break;
          case "reload":
            app.auxData.reload = Math.random();
            if ((event?.properties?.rootEvent && formInstance.isRootDocument) || event?.properties?.detachedEvent) {
              formInstance.onAction('reload');
            } else {
              app.$emit("action", "reload");
            }
            break;
          case "routeTo":
            let params = {};
            let url = event.value;
            if (event?.properties?.onEventVariableSchema) {
              params = mapFormDataBySchema(JSON.parse(event?.properties?.onEventVariableSchema), data);
              url = event.value
                .split("/")
                .map((el) => (el[0] === ":" ? params[el.split(":")[1]] : el))
                .join("/");
            }
            app.$router.push({
              path: url,
            });
            break;
          case "openForm":
            let formVal = event.value;
            if (event.value && typeof event.value === "string") {
              try {
                formVal = eval(event.value.replace(/this(\?)?\./g, "app."));
              } catch (err) {
                console.log(err);
              }
            }

            if (data && data?.action?.properties?.rowKey) {
              app.$router.push(
                `/page/${formVal}/?${data.action.properties.rowKey}=${data.data[data.action.properties.rowKey]}`
              );
            } else {
              app.$router.push(`/page/${formVal}/`);
            }
            break;
          case "openModal":
            let modalValue = event.value;
            if (event.value && typeof event.value === "string") {
              try {
                modalValue = eval(event.value.replace(/this(\?)?\./g, "app."));
              } catch (err) {
                console.log(err);
              }
            }

            if (event.properties.onEventVariableSchemaIsScript) {
              event.properties.onEventVariableSchemaJSON = JSON.stringify(
                eval(event.properties.onEventVariableSchema.replace(/this(\?)?\./g, "app."))
              );
            }

            if ((event?.properties?.rootEvent && formInstance.isRootDocument) || event?.properties?.detachedEvent) {
              formInstance.onAction('openFormInModal', {...event, value: modalValue}, data);
            } else {
              app.$emit("action", "openFormInModal", {...event, value: modalValue}, data);
            }
            break;
          case "setVariable":
            let value = event.value.value;
            if (/script/.test(event.value.type)) {
              try {
                value = eval(value.replace(/this(\?)?\./g, "app."));
              } catch (e) {
                value = objectVariable(data, event.value.variable) || data?.data;
              }
            } else if (/object/.test(event.value.type)) {
              try {
                if (value && !/^\${/.test(value))
                  value = mapFormDataBySchema(JSON.parse(value), data);
                else
                  value = objectVariable(data, event.value.variable) || data?.data;
              } catch (e) {
                value = objectVariable(data, event.value.variable) || data?.data;
              }
            }
            objectVariable(app, event.value.variable, value);
            break;
          case "executeEvents":
            if (event.value?.properties?.events?.length) {
              await executeActions(app, event.value?.properties?.events, data, element, dataToUpdate, formInstance, pdfSignerRes);
            }
            break;
          case "runScript":
            try {
              eval(event.value.replace(/this(\?)?\./g, "app."));
            } catch (err) {
              console.log(
                "%crunScript:%c" + event.value + "%cError:" + err,
                "color: red; font-weight: bold;",
                "color: darkblue",
                "color: red; font-weight: bold;"
              );
            }
            break;
          case "stopOrContinue":
            try {
              const branchTrue = eval(event.value.replace(/this(\?)?\./g, "app."));
              if (branchTrue) {
                setTimeout(() => {
                  const remainActions = actions.filter((a) => executedActions.indexOf(a.action.id) === -1);
                  if (remainActions.length) {
                    executeActions(app, remainActions, data, element, dataToUpdate, formInstance, pdfSignerRes);
                  }
                }, 300);
              }
              return;
            } catch (err) {
              isValid = false;
              console.log(
                "%cstopOrContinue:%c" + event.value + "%cError:" + err,
                "color: red; font-weight: bold;",
                "color: darkblue",
                "color: red; font-weight: bold;"
              );
            }
            break;
          case "ifElse":
            try {
              const branchTrue = eval(event.value.replace(/this(\?)?\./g, "app."));
              if (branchTrue) {
                setTimeout(() => {
                  let positiveEvents = event?.properties?.events?.filter((a) => executedActions.indexOf(a.action.id) === -1 && (a.properties?.positiveBranch || a.properties?.ignoreBranch))
                  const remainActions = [...(positiveEvents || []), ...(actions?.filter((a) => executedActions.indexOf(a.action.id) === -1) || [])];
                  //const remainActions = event?.properties?.events?.filter((a) => executedActions.indexOf(a.action.code) === -1 && a.properties?.positiveBranch)
                  if (remainActions.length) {
                    executeActions(app, remainActions, data, element, dataToUpdate, formInstance);
                  }
                }, hasValidate ? 300 : 0);
              } else {
                setTimeout(() => {
                  let negativeEvents = event?.properties?.events?.filter((a) => executedActions.indexOf(a.action.id) === -1 && (!a.properties?.positiveBranch || a.properties?.ignoreBranch))
                  const remainActions = [...(negativeEvents || []), ...(actions?.filter((a) => executedActions.indexOf(a.action.id) === -1) || [])];
                  if (remainActions.length) {
                    executeActions(app, remainActions, data, element, dataToUpdate, formInstance);
                  }
                }, 300);
              }
              return;
            } catch (err) {
              isValid = false;
              console.log(
                "%cifElse:%c" + event.value + "%cError:" + err,
                "color: red; font-weight: bold;",
                "color: darkblue",
                "color: red; font-weight: bold;"
              );
            }
            break;
          case "validate":
            hasValidate = true;
            if ((event?.properties?.rootEvent && formInstance.isRootDocument) || event?.properties?.detachedEvent) {
              formInstance.onAction("validate", event.value);
            } else {
              app.$emit("action", "validate", event.value);
            }
            await waitForValidation(app);
            setTimeout(() => {
              if (app.isGlobalValid) {
                isValid = true;
                const remainActions = actions.filter((a) => executedActions.indexOf(a.action.id) === -1);
                if (remainActions.length) {
                  executeActions(app, remainActions, data, element, dataToUpdate, formInstance);
                }
              }
            }, 300);
            break;
          case "resetValidation":
            hasValidate = false;
            if ((event?.properties?.rootEvent && formInstance.isRootDocument) || event?.properties?.detachedEvent) {
              formInstance.onAction('resetValidation');
            } else {
              app.$emit("action", "resetValidation");
            }
            isValid = true;
            break;
          case "confirm":
            hasConfirm = true;
            setTimeout(
              () => {
                if (app.isGlobalValid) {
                  app.$confirm.close();
                  app.$confirm.require({
                    group: 'formConfirm',
                    message: event?.value?.message ? event?.value?.message : app.$t("Are you sure?"),
                    header: event?.value?.header ? event?.value?.header : app.$t("Confirm action"),
                    icon: "pi pi-exclamation-triangle",
                    acceptLabel: app.$t("yes"),
                    rejectLabel: app.$t("no"),
                    acceptIcon: "fa fa-check",
                    rejectIcon: "fa fa-times",
                    accept: () => {
                      hasConfirm = false;
                      isConfirmed = true;
                      const remainActions = actions.filter((a) => executedActions.indexOf(a.action.id) === -1);
                      if (remainActions.length) {
                        setTimeout(() => {
                          executeActions(app, remainActions, data, element, dataToUpdate, formInstance);
                        }, 300);
                      }
                    },
                    reject: () => {
                      isConfirmed = false;
                    },
                  });
                }
              },
              hasValidate ? 300 : 0
            );
            break;
          case "endpointCall":
            if (event.value.fromSelect || event.value.fromDataTable) {
              checkDataSource(app, event.value, null, {...(data || {}), ...(data?.data || {})}, null, null, formInstance);
            } else {
              setTimeout(
                () => {
                  checkDataSource(app, event.value, null, {...(data || {}), ...(data?.data || {})}, hasValidate, null, formInstance, element);
                },
                hasValidate ? 300 : 0
              );
            }
            break;
          case "viewReport":
            let auxVal = event.value;
            if (event.value && typeof event.value === "string") {
              try {
                auxVal = eval(event.value.replace(/this(\?)?\./g, "app."));
              } catch (err) {
                console.log(err);
              }
            }

            auxVariables = [];
            if (event.properties.variables) {
              event.properties.variables.forEach((variable) => {
                const auxVar = _.cloneDeep(variable);
                if (/script/.test(auxVar.type)) {
                  try {
                    auxVar.value = eval(auxVar.value.replace(/this(\?)?\./g, "app."));
                  } catch (e) {
                    auxVar.value = objectVariable(data, auxVar.value) || data?.data;
                  }
                } else if (/object/.test(auxVar.type)) {
                  try {
                    auxVar.value = mapFormDataBySchema(JSON.parse(auxVar.value), data);
                  } catch (e) {
                    auxVar.value = objectVariable(data, auxVar.value) || data?.data;
                  }
                }
                if (auxVar.spread && typeof auxVar.value === "object") {
                  Object.keys(auxVar.value).forEach((auxVarKey) => {
                    const spreadVar = {name: auxVarKey, value: auxVar.value[auxVarKey]};
                    auxVariables.push(spreadVar);
                  });
                } else auxVariables.push(auxVar);
              });
            }
            const {default: ReportViewer} = await import('@/pages/report/ReportViewer.vue');
            app.$dialog.open(h(ReportViewer), {
              props: {
                modal: true,
                contentClass: "border-round-bottom",
                style: "max-width: 1024px",
                maximizable: true,
              },
              data: {
                variables: auxVariables,
                documentTypeId: auxVal,
              },
              templates: {
                header: h(
                  "span",
                  {
                    class: "p-dialog-title mr-5",
                  },
                  app.$t("Document preview")
                ),
              },
            });
            break;
          case "signPDF":
            const {default: PdfSigner} = await import('@/components/common/PdfSigner.vue');
            pdfSignerRes = {};
            try {
              const pdfProps = eval(event.value.replace(/this(\?)?\./g, "app."));
              await new Promise((res, rej) => {
                app.$dialog.open(h(PdfSigner), {
                  props: {
                    modal: true,
                    contentClass: 'border-round-bottom',
                    contentStyle: 'padding: 0 !important',
                    style: 'width: 100vw; height: 100vh; max-height: unset; padding: 0 !important;',
                    showHeader: false
                  },
                  data: {
                    ...pdfProps
                  },
                  emits: {
                    onClose: () => res(),
                    onSaveItems: (arr) => {
                      pdfSignerRes = arr;
                      res();
                    }
                  }
                });
              })
            } catch (err) {
              console.log(
                "%crunScript:%c" + event.value + "%cError:" + err,
                "color: red; font-weight: bold;",
                "color: darkblue",
                "color: red; font-weight: bold;"
              );
            }
            break;
          case "canvasView":
            const {default: CanvasDocViewer} = await import('@/components/common/CanvasDocViewer.vue');
            const pdfProps = eval(event.value.replace(/this(\?)?\./g, "app."));
            app.$dialog.open(h(CanvasDocViewer), {
              props: {
                modal: true,
                contentClass: 'border-round-bottom',
                contentStyle: 'padding: 0 !important',
                style: 'width: 100vw; height: 100vh; max-height: unset; padding: 0 !important;',
                showHeader: false
              },
              data: {
                ...pdfProps
              }
            });
            break;
          case "viewPDF":
            auxValView = event.value;
            if (event.value && typeof event.value === "string") {
              try {
                auxValView = eval(event.value.replace(/this(\?)?\./g, "app."));
              } catch (err) {
                console.log(err);
              }
            }

            auxVariables = [];
            if (event.properties.variables) {
              event.properties.variables.forEach((variable) => {
                const auxVar = _.cloneDeep(variable);
                if (/script/.test(auxVar.type)) {
                  try {
                    auxVar.value = eval(auxVar.value.replace(/this(\?)?\./g, "app."));
                  } catch (e) {
                    auxVar.value = objectVariable(data, auxVar.value) || data?.data;
                  }
                } else if (/object/.test(auxVar.type)) {
                  try {
                    auxVar.value = mapFormDataBySchema(JSON.parse(auxVar.value), data);
                  } catch (e) {
                    auxVar.value = objectVariable(data, auxVar.value) || data?.data;
                  }
                }
                if (auxVar.spread && typeof auxVar.value === "object") {
                  Object.keys(auxVar.value).forEach((auxVarKey) => {
                    const spreadVar = {name: auxVarKey, value: auxVar.value[auxVarKey]};
                    auxVariables.push(spreadVar);
                  });
                } else auxVariables.push(auxVar);
              });
            }
            const {default: ReportPDF} = await import("@/pages/report/ReportPDF.vue");
            await new Promise((res, rej) => {
              app.$dialog.open(h(ReportPDF), {
                props: {
                  modal: true,
                  contentClass: "border-round-bottom",
                  style: "width: 80vw;height:80vh;",
                  maximizable: true,
                },
                data: {
                  variables: auxVariables,
                  documentTypeId: auxValView,
                },
                templates: {
                  header: h(
                    "span",
                    {
                      class: "p-dialog-title mr-5",
                    },
                    app.$t("Document preview")
                  ),
                },
                onClose: (pdf) => {
                  if (pdf?.data) {
                    data.pdfRes = pdf;
                    if (event.properties?.events?.length) {
                      executeActions(app, event.properties?.events, data, element, dataToUpdate, formInstance, pdfSignerRes);
                    }
                  }
                  res();
                }
              });
            });
            break;
          case "viewWord":
            auxValView = event.value;
            if (event.value && typeof event.value === "string") {
              try {
                auxValView = eval(event.value.replace(/this(\?)?\./g, "app."));
              } catch (err) {
                console.log(err);
              }
            }

            auxVariables = [];
            if (event.properties.variables) {
              event.properties.variables.forEach((variable) => {
                const auxVar = _.cloneDeep(variable);
                if (/script/.test(auxVar.type)) {
                  try {
                    auxVar.value = eval(auxVar.value.replace(/this(\?)?\./g, "app."));
                  } catch (e) {
                    auxVar.value = objectVariable(data, auxVar.value) || data?.data;
                  }
                } else if (/object/.test(auxVar.type)) {
                  try {
                    auxVar.value = mapFormDataBySchema(JSON.parse(auxVar.value), data);
                  } catch (e) {
                    auxVar.value = objectVariable(data, auxVar.value) || data?.data;
                  }
                }
                if (auxVar.spread && typeof auxVar.value === "object") {
                  Object.keys(auxVar.value).forEach((auxVarKey) => {
                    const spreadVar = {name: auxVarKey, value: auxVar.value[auxVarKey]};
                    auxVariables.push(spreadVar);
                  });
                } else auxVariables.push(auxVar);
              });
            }
            const {default: ReportWord} = await import("@/pages/report/ReportWord.vue");
            app.$dialog.open(h(ReportWord), {
              props: {
                modal: true,
                contentClass: "border-round-bottom",
                style: "width: 20rem;height:20rem; min-width: fit-content;",
                maximizable: true
              },
              data: {
                variables: auxVariables,
                documentTypeId: auxValView,
              },
              templates: {
                header: h(
                  "span",
                  {
                    class: "p-dialog-title mr-5",
                  },
                  app.$t("Document preview")
                ),
              },
            });
            break;
          case "viewExcel":
            auxValView = event.value;
            if (event.value && typeof event.value === "string") {
              try {
                auxValView = eval(event.value.replace(/this(\?)?\./g, "app."));
              } catch (err) {
                console.log(err);
              }
            }

            auxVariables = [];
            if (event.properties.variables) {
              event.properties.variables.forEach((variable) => {
                const auxVar = _.cloneDeep(variable);
                if (/script/.test(auxVar.type)) {
                  try {
                    auxVar.value = eval(auxVar.value.replace(/this(\?)?\./g, "app."));
                  } catch (e) {
                    auxVar.value = objectVariable(data, auxVar.value) || data?.data;
                  }
                } else if (/object/.test(auxVar.type)) {
                  try {
                    auxVar.value = mapFormDataBySchema(JSON.parse(auxVar.value), data);
                  } catch (e) {
                    auxVar.value = objectVariable(data, auxVar.value) || data?.data;
                  }
                }
                if (auxVar.spread && typeof auxVar.value === "object") {
                  Object.keys(auxVar.value).forEach((auxVarKey) => {
                    const spreadVar = {name: auxVarKey, value: auxVar.value[auxVarKey]};
                    auxVariables.push(spreadVar);
                  });
                } else auxVariables.push(auxVar);
              });
            }
            const {default: ReportExcel} = await import("@/pages/report/ReportExcel.vue");
            app.$dialog.open(h(ReportExcel), {
              props: {
                modal: true,
                contentClass: "border-round-bottom",
                style: "width: 20rem;height:20rem; min-width: fit-content;",
                maximizable: true
              },
              data: {
                variables: auxVariables,
                documentTypeId: auxValView,
              },
              templates: {
                header: h(
                  "span",
                  {
                    class: "p-dialog-title mr-5",
                  },
                  app.$t("Document preview")
                ),
              },
            });
            break;
          case 'fileUpload':
            hasValidate = true;
            // Create a file input element
            const fileInput = document.createElement('input');
            fileInput.accept = event?.properties?.accept ? event.properties.accept : '*';
            fileInput.type = 'file';
            fileInput.multiple = event?.properties?.isMultiple === true;

            // Add an event listener to handle file selection
            fileInput.addEventListener('change', function () {
              // Handle the selected file(s) here
              const tempFile = event?.properties?.isMultiple === true ? fileInput.files : fileInput.files[0];

              isValid = true;
              setTimeout(() => {
                const remainActions = actions.filter((a) => executedActions.indexOf(a.action.id) === -1);
                if (remainActions.length) {
                  executeActions(app, remainActions, {...data, tempFile: tempFile}, element, dataToUpdate, formInstance);
                }
              }, 300);
            });

            // Trigger the click event programmatically
            fileInput.click();
            isValid = false;
            break

          //  THIS ACTION WAS ADDED BY VLADUT ON 27.03.2024
          // PURPOSE OF THE ACTION IS TO OPEN A PICTURE IN THE KONVA PICTURE EDITOR
          case "openKonvaPictureEditor":
            try {
              const pictureProps = eval(event.value.replace(/this(\?)?\./g, "app."));
              const {default: KonvaPictureEditor} = await import('@/components/common/konva-picture-editor/PictureKonvaEditor.vue');
              await new Promise((res, rej) => {
                app.$dialog.open(h(KonvaPictureEditor), {
                  props: {
                    modal: true,
                    contentClass: 'border-round-bottom',
                    contentStyle: 'padding: 0 !important',
                    style: 'width: 100vw; height: 100vh; max-height: unset; padding: 0 !important;',
                    showHeader: false
                  },
                  data: {
                    ...pictureProps
                  },
                  emits: {
                    onClose: () => res(),
                    /**
                     * uri means the new picture uri
                     */
                    onSaveItems: (uri) => {
                      try {
                        const callback = eval(event.callback.replace(/this(\?)?\./g, "app."));
                        callback(uri);
                      } catch (err) {
                        console.log(
                          "%crunScript:%c" + event.value + "%cError:" + err,
                          "color: red; font-weight: bold;",
                          "color: darkblue",
                          "color: red; font-weight: bold;"
                        );
                      }
                      res();
                    }
                  }
                });
              })
            } catch (err) {
              console.log(
                "%crunScript:%c" + event.value + "%cError:" + err,
                "color: red; font-weight: bold;",
                "color: darkblue",
                "color: red; font-weight: bold;"
              );
            }

            break;

          case "showToastTemplate":
            try {
              formInstance.auxData.toast[event.value] = true;
            } catch (err) {
              console.log(
                "%cshowToastTemplate:%c" + event.value + "%cError:" + err,
                "color: red; font-weight: bold;",
                "color: darkblue",
                "color: red; font-weight: bold;"
              );
            }
            break;

          default:
            break;
        }
      }
      if (event?.properties?.onEvent) {
        if ((event?.properties?.rootEvent && formInstance.isRootDocument) || event?.properties?.detachedEvent) {
          formInstance.onAction("onEvent", event, data);
        } else {
          app.$emit("action", "onEvent", event, data);
        }
      }
    }
    if (event?.event?.value === "iFrameMessage") {
      delete data.windowMessage;
    }

    /*const loadEvents = event?.properties?.events?.filter(ev => ev?.event?.value === 'load')
    if(loadEvents){
      await executeActions(app, loadEvents, data, element, dataToUpdate)
    }*/
  }
}

/**
 * Recursive reset options array for elements that use a data source
 * @param arr
 * @returns {*}
 */
export function emptyDocumentDataSourceOptions(arr) {
  if (Array.isArray(arr)) {
    for (let x = 0; x < arr.length; x++) {
      if (arr[x]?.properties?.useDataSource && arr[x]?.properties?.options) {
        arr[x].properties.options = [];
      }
      if (arr[x].children) {
        emptyDocumentDataSourceOptions(arr[x].children);
      }
      if (arr[x]?.properties?.fields) {
        emptyDocumentDataSourceOptions(arr[x].properties.fields);
      }
    }
  }
  return arr;
}

export const TaskItemType = {
  Stage: 1,
  Branches: 2,
  Form: 3,
  Actions: 4,
  Conditions: 5,
  Processes: 6,
  Jobs: 7,
  Action_Positive: 8,
  Action_Neutral: 9,
  Action_Negative: 10,
  Condition_Positive: 11,
  Condition_Negative: 12,
  Process_Change_Status: 13,
  Process_Change_Department: 14,
  Process_Change_Responsible: 15,
  Process_Generate_Number: 16,
  Process_Change_Document: 17,
  Process_Change_Document_Details: 18,
  Email_Notification: 19,
  Sms_Notification: 20,
  Web_Notification: 21,
  Process_Register_Digital_Certificate: 22,
  Process_Trigger_Next_Stage: 23,
  Process_Change_Status_Document_Details: 24,
  Process_Action_Log_Document: 25,
  Process_Action_Log_Document_Detail: 26,
  Process_Generate_Detail_Number: 27,
  Job: 29,
  State: 30,
  Process_Upsert_Geometry: 31,
  Process_Upsert_Geometry_By_DocumentDetail_Geometry: 32,
  Process_Clone_Layer: 33,
  Process_Generate_External_Number: 35,
  Process_Execute_Flow: 36
}

export const taskItemIcons = {
  [TaskItemType.Stage]: 'fa-sign-in',
  [TaskItemType.Conditions]: 'fa-random',
  [TaskItemType.Actions]: 'fa-hand-pointer-o',
  [TaskItemType.Action_Positive]: 'fa-check-circle-o',
  [TaskItemType.Action_Positive]: 'fa-times-circle-o',
  [TaskItemType.Action_Neutral]: 'fa-dot-circle-o',
  [TaskItemType.Condition_Positive]: 'fa-check',
  [TaskItemType.Condition_Negative]: 'fa-times',
  [TaskItemType.Processes]: 'fa-terminal',
  [TaskItemType.Process_Change_Status]: 'fa-terminal',
  [TaskItemType.Process_Change_Department]: 'fa-terminal',
  [TaskItemType.Process_Change_Responsible]: 'fa-terminal',
  [TaskItemType.Process_Generate_Number]: 'fa-terminal',
  [TaskItemType.Process_Change_Document]: 'fa-terminal',
  [TaskItemType.Process_Change_Document_Details]: 'fa-terminal',
  [TaskItemType.Process_Register_Digital_Certificate]: 'fa-terminal',
  [TaskItemType.Process_Trigger_Next_Stage]: 'fa-terminal',
  [TaskItemType.Email_Notification]: 'fa-terminal',
  [TaskItemType.Sms_Notification]: 'fa-terminal',
  [TaskItemType.Web_Notification]: 'fa-terminal',
  [TaskItemType.Process_Change_Status_Document_Details]: 'fa-terminal',
  [TaskItemType.Process_Action_Log_Document]: 'fa-terminal',
  [TaskItemType.Process_Action_Log_Document_Detail]: 'fa-terminal',
  [TaskItemType.Process_Generate_Detail_Number]: 'fa-terminal',
  [TaskItemType.Process_Generate_External_Number]: 'fa-terminal',
  [TaskItemType.Process_Upsert_Geometry]: 'fa-terminal',
  [TaskItemType.Process_Upsert_Geometry_By_DocumentDetail_Geometry]: 'fa-terminal',
  [TaskItemType.Process_Clone_Layer]: 'fa-terminal',
  [TaskItemType.Process_Execute_Flow]: 'fa-terminal',
  [TaskItemType.Job]: 'fa-terminal',
  [TaskItemType.Jobs]: 'fa-terminal',
  [TaskItemType.State]: 'fa-dot-circle-o'
}

export const taskItemLabels = {
  [TaskItemType.Stage]: 'Stage',
  [TaskItemType.Branches]: 'Branches',
  [TaskItemType.Form]: 'Form',
  [TaskItemType.Actions]: 'Actions',
  [TaskItemType.Conditions]: 'Conditions',
  [TaskItemType.Processes]: 'Processes',
  [TaskItemType.Jobs]: 'Jobs',
  [TaskItemType.Action_Positive]: 'Action Positive',
  [TaskItemType.Action_Neutral]: 'Action Neutral',
  [TaskItemType.Action_Negative]: 'Action Negative',
  [TaskItemType.Condition_Positive]: 'Condition Positive',
  [TaskItemType.Condition_Negative]: 'Condition Negative',
  [TaskItemType.Process_Change_Status]: 'Process Change Status',
  [TaskItemType.Process_Change_Department]: 'Process Change Department',
  [TaskItemType.Process_Change_Responsible]: 'Process Change Responsible',
  [TaskItemType.Process_Generate_Number]: 'Process Generate Number',
  [TaskItemType.Process_Change_Document]: 'Process Change Document',
  [TaskItemType.Process_Change_Document_Details]: 'Process Change Document Details',
  [TaskItemType.Email_Notification]: 'Email Notification',
  [TaskItemType.Sms_Notification]: 'Sms Notification',
  [TaskItemType.Web_Notification]: 'Web Notification',
  [TaskItemType.Process_Register_Digital_Certificate]: 'Process Register Digital Certificate',
  [TaskItemType.Process_Trigger_Next_Stage]: 'Process Trigger Next Stage',
  [TaskItemType.Process_Change_Status_Document_Details]: 'Process Change Status Document Details',
  [TaskItemType.Process_Action_Log_Document]: 'Process Action Log Document',
  [TaskItemType.Process_Action_Log_Document_Detail]: 'Process Action Log Document Detail',
  [TaskItemType.Process_Generate_Detail_Number]: 'Process Generate Detail Number',
  [TaskItemType.Process_Generate_External_Number]: 'Process Generate External Number',
  [TaskItemType.Process_Upsert_Geometry]: 'Process Upsert Geometry',
  [TaskItemType.Process_Upsert_Geometry_By_DocumentDetail_Geometry]: 'Process Upsert Geometry By Document Detail Geometry',
  [TaskItemType.Process_Clone_Layer]: 'Process Clone Layer',
  [TaskItemType.Process_Execute_Flow]: 'Process Execute Flow Event',
  [TaskItemType.Job]: 'Job',
  [TaskItemType.State]: 'State'
}

export const taskMax = {
  [TaskItemType.Stage]: {output: null, input: null},
  [TaskItemType.Branches]: {output: null, input: 1},
  [TaskItemType.Form]: {output: null, input: 1},
  [TaskItemType.Actions]: {output: null, input: 1},
  [TaskItemType.Conditions]: {output: null, input: 1},
  [TaskItemType.Processes]: {output: null, input: 1},
  [TaskItemType.Jobs]: {output: null, input: 1},
  [TaskItemType.Action_Positive]: {output: null, input: 1},
  [TaskItemType.Action_Neutral]: {output: null, input: 1},
  [TaskItemType.Action_Negative]: {output: null, input: 1},
  [TaskItemType.Condition_Positive]: {output: null, input: 1},
  [TaskItemType.Condition_Negative]: {output: null, input: 1},
  [TaskItemType.Process_Change_Status]: {output: null, input: 1},
  [TaskItemType.Process_Change_Department]: {output: null, input: 1},
  [TaskItemType.Process_Change_Responsible]: {output: null, input: 1},
  [TaskItemType.Process_Generate_Number]: {output: null, input: 1},
  [TaskItemType.Process_Change_Document]: {output: null, input: 1},
  [TaskItemType.Process_Change_Document_Details]: {output: null, input: 1},
  [TaskItemType.Email_Notification]: {output: null, input: 1},
  [TaskItemType.Sms_Notification]: {output: null, input: 1},
  [TaskItemType.Web_Notification]: {output: null, input: 1},
  [TaskItemType.Process_Register_Digital_Certificate]: {output: null, input: 1},
  [TaskItemType.Process_Trigger_Next_Stage]: {output: null, input: 1},
  [TaskItemType.Process_Change_Status_Document_Details]: {output: null, input: 1},
  [TaskItemType.Process_Action_Log_Document]: {output: null, input: 1},
  [TaskItemType.Process_Action_Log_Document_Detail]: {output: null, input: 1},
  [TaskItemType.Process_Generate_Detail_Number]: {output: null, input: 1},
  [TaskItemType.Process_Generate_External_Number]: {output: null, input: 1},
  [TaskItemType.Process_Upsert_Geometry]: {output: null, input: 1},
  [TaskItemType.Process_Upsert_Geometry_By_DocumentDetail_Geometry]: {output: null, input: 1},
  [TaskItemType.Process_Clone_Layer]: {output: null, input: 1},
  [TaskItemType.Process_Execute_Flow]: {output: null, input: 1},
  [TaskItemType.Job]: {output: null, input: 1},
  [TaskItemType.State]: {output: null, input: null},
}

export const taskChildrenTypes = {
  [TaskItemType.Stage]: [
    TaskItemType.Actions,
    TaskItemType.Conditions,
    TaskItemType.Jobs
  ],
  [TaskItemType.Conditions]: [
    TaskItemType.Condition_Positive,
    TaskItemType.Condition_Negative
  ],
  [TaskItemType.Condition_Positive]: [
    TaskItemType.Actions,
    TaskItemType.Conditions
  ],
  [TaskItemType.Condition_Negative]: [
    TaskItemType.Actions,
    TaskItemType.Conditions
  ],
  [TaskItemType.Actions]: [
    TaskItemType.Action_Positive,
    TaskItemType.Action_Neutral,
    TaskItemType.Action_Negative
  ],
  [TaskItemType.Action_Positive]: [
    TaskItemType.Processes
  ],
  [TaskItemType.Action_Neutral]: [
    TaskItemType.Processes
  ],
  [TaskItemType.Action_Negative]: [
    TaskItemType.Processes
  ],
  [TaskItemType.Processes]: [
    TaskItemType.Process_Change_Status,
    TaskItemType.Process_Change_Department,
    TaskItemType.Process_Change_Responsible,
    TaskItemType.Process_Generate_Number,
    TaskItemType.Process_Change_Document,
    TaskItemType.Process_Change_Document_Details,
    TaskItemType.Process_Register_Digital_Certificate,
    TaskItemType.Process_Trigger_Next_Stage,
    TaskItemType.Email_Notification,
    TaskItemType.Sms_Notification,
    TaskItemType.Web_Notification,
    TaskItemType.Process_Change_Status_Document_Details,
    TaskItemType.Process_Action_Log_Document,
    TaskItemType.Process_Action_Log_Document_Detail,
    TaskItemType.Process_Generate_Detail_Number,
    TaskItemType.Process_Generate_External_Number,
    TaskItemType.Process_Upsert_Geometry,
    TaskItemType.Process_Upsert_Geometry_By_DocumentDetail_Geometry,
    TaskItemType.Process_Clone_Layer,
    TaskItemType.Process_Execute_Flow
  ],
  [TaskItemType.Jobs]: [
    TaskItemType.Job
  ]
}

export function getCurrentStageOptions(obj, origStage, formInstance, zoneId = undefined) {
  if (!origStage) {
    return {buttons: [], rowActions: []};
  }
  let stage = JSON.parse(JSON.stringify(origStage));
  if (stage.flowProperties && stage.flowProperties.length) {
    let auxChildren = JSON.stringify(stage.children);
    stage.flowProperties.forEach(fp => {
      auxChildren = auxChildren.replaceAll(fp.name, fp.value);
    })
    try {
      stage.children = JSON.parse(auxChildren);
    } catch (error) {
      console.warn('Failed to parse auxChildren, using original children:', error);
    }
  }

  const stageDoc = obj.document;
  const stageUser = obj.user;

  const currentTaskOptions = {
    buttons: [],
    rowActions: []
  };

  const parseTaskChildren = (children) => {
    children.forEach(child => {
      switch (child.taskTypeId) {
        case TaskItemType.Actions:
          handleActions(child);
          break;
        case TaskItemType.Conditions:
          handleCondition(child);
          break;
      }
    });
  };

  const handleActions = (actions) => {
    if (!actions?.children || !Array.isArray(actions.children)) return;

    actions.children.sort((a, b) => {
      if (!a || !b) return 0;
      if (a.position === b.position) return 0;
      return (a?.position || 0) > (b?.position || 0) ? 1 : -1;
    }).forEach(child => {
      if (child.properties) {
        if ((!!child.properties.zoneId || !!zoneId) && child.properties.zoneId != zoneId) return;
        if (child.properties.buttonProperties) {
          currentTaskOptions.buttons.push({
            ...child.properties.buttonProperties,
            documentTaskId: child.documentTaskId,
            // xPos: child.properties?.metadata?.position?.x || 0
          });
        }
        if (child.properties.rowActionProperties) {
          currentTaskOptions.rowActions.push({
            ...child.properties.rowActionProperties,
            documentTaskId: child.documentTaskId,
            // xPos: child.properties?.metadata?.position?.x || 0
          });
        }
      }
    });
  };

  const handleCondition = (condition) => {
    const parsedCondition = eval(condition.properties.conditions.join(' && '));
    let items = [];
    if (parsedCondition) {
      const conditionPositive = condition.children.find(child => child.taskTypeId === TaskItemType.Condition_Positive);
      if (conditionPositive)
        items = conditionPositive.children;
    } else {
      const conditionNegative = condition.children.find(child => child.taskTypeId === TaskItemType.Condition_Negative);
      if (conditionNegative)
        items = conditionNegative.children;
    }
    parseTaskChildren(orderChildrenGroups(items));
  };

  const orderChildrenGroups = (children) => {
    if (!children) return [];
    return [
      ...children.filter(ch => ![TaskItemType.Actions, TaskItemType.Conditions, TaskItemType.Condition_Positive, TaskItemType.Condition_Negative].includes(ch.taskTypeId)),
      ...children.filter(ch => ch.taskTypeId === TaskItemType.Actions).sort((a, b) => a?.position > b?.position ? 1 : -1),
      ...children.filter(ch => ch.taskTypeId === TaskItemType.Conditions).sort((a, b) => a?.properties?.metadata?.position?.x > b?.properties?.metadata?.position?.x ? 1 : -1),
      ...children.filter(ch => ch.taskTypeId === TaskItemType.Condition_Positive).sort((a, b) => a?.properties?.metadata?.position?.x > b?.properties?.metadata?.position?.x ? 1 : -1),
      ...children.filter(ch => ch.taskTypeId === TaskItemType.Condition_Negative).sort((a, b) => a?.properties?.metadata?.position?.x > b?.properties?.metadata?.position?.x ? 1 : -1)
    ]
  }
  parseTaskChildren(orderChildrenGroups(stage.children));
  // if (currentTaskOptions.buttons)
  //   currentTaskOptions.buttons = currentTaskOptions.buttons.sort((a, b) =>
  //     a.xPos > b.xPos ? 1 : b.xPos > a.xPos ? -1 : 0
  //   );
  // if (currentTaskOptions.rowActions)
  //   currentTaskOptions.rowActions = currentTaskOptions.rowActions.sort((a, b) =>
  //     a.xPos > b.xPos ? 1 : b.xPos > a.xPos ? -1 : 0
  //   );
  return currentTaskOptions;
}

export function getGlobalComponents(arr) {
  const globalComponents = [];
  if (Array.isArray(arr)) {
    for (let x = 0; x < arr.length; x++) {
      if (arr[x]?.properties?.type === "global") {
        if (!globalComponents.find((gc) => gc.documentId === arr[x].properties.formId)) {
          globalComponents.push({
            documentId: arr[x].properties.formId,
            title: arr[x].properties.overridden ? arr[x].properties.overridden.title : "Global",
          });
        }
      }
      if (arr[x].children) {
        globalComponents.push(...getGlobalComponents(arr[x].children));
      }
    }
  }
  return globalComponents;
}

export function clearMissingGlobalComponents(arr, globalComponents) {
  if (Array.isArray(arr)) {
    const missingIndexes = [];
    for (let x = 0; x < arr.length; x++) {
      if (arr[x]?.properties?.type === "global") {
        if (!globalComponents.find((gc) => gc.documentId === arr[x].properties.formId)) missingIndexes.push(x);
      }
      if (arr[x].children) {
        clearMissingGlobalComponents(arr[x].children, globalComponents);
      }
    }
    missingIndexes.forEach((mi) => {
      arr.splice(mi, 1);
    });
  }
}

export function formatGlobalComponents(arrOrig, cachedGlobalComponents) {
  let arr = _.cloneDeep(arrOrig);
  if (Array.isArray(arr)) {
    for (let x = 0; x < arr.length; x++) {
      if (arr[x]?.properties?.type === "global") {
        arr[x] = formatGlobalComponent(arr[x], cachedGlobalComponents);
      } else if (arr[x]?.children && arr[x]?.children?.length) {
        arr[x].children = formatGlobalComponents(arr[x].children, cachedGlobalComponents);
      }
    }
  }
  return arr;
}

export function formatGlobalComponent(compOrig, cachedGlobalComponents) {
  let comp = _.cloneDeep(compOrig);
  if (comp.children && _.values(comp.children).length) {
    for (let x = 0; x < _.values(comp.children).length; x++) {
      if (comp.children[x]?.properties?.type === "global") {
        comp.children[x] = formatGlobalComponent(comp.children[x], cachedGlobalComponents);
      } else if (comp.children[x].children && _.values(comp.children[x].children).length) {
        comp.children[x].children = formatGlobalComponents(comp.children[x].children, cachedGlobalComponents);
      }
    }
  }
  comp = formatGlobalComponentDetail(comp);
  delete comp.children;
  return comp;
}

export function formatGlobalComponentDetail(detailOrig) {
  let detail = _.cloneDeep(detailOrig);
  const overrideDetails = [];
  detail.properties?.overridden?.documentDetails?.forEach((dd) => {
    const origD = detail.properties.component.documentDetails.find((od) => od.documentDetailId === dd.documentDetailId);
    if (!origD) {
      overrideDetails.push(dd);
    } else {
      const changes = findDifferences(dd, origD);
      if (changes.documentDetails) delete changes.documentDetails;
      const flattenedChanges = extractOnlyModified(changes);
      overrideDetails.push(...flattenedChanges);
    }
  });
  detail.properties?.component?.documentDetails?.forEach((dd) => {
    const newD = detail.properties.overridden.documentDetails.find((od) => od.documentDetailId === dd.documentDetailId);
    if (!newD) overrideDetails.push({documentDetailId: dd.documentDetailId, parentDetail: true});
  });
  detail.properties.overrideDetails = overrideDetails;
  delete detail.properties.overridden;
  delete detail.properties.component;
  return detail;
}

export function extractOnlyModified(changes) {
  const flatChanges = [];
  const recursiveCheck = (obj, insideGlobalComponent = false) => {
    if (typeof obj === 'object') {
      let innerGlobalComponent = insideGlobalComponent;
      if (!innerGlobalComponent) {
        innerGlobalComponent = obj?.properties?.type === 'global';
      }
      if (obj?.properties?.type === 'instanceContent' && !innerGlobalComponent) {
        flatChanges.push(obj);
        return;
      } else if (obj?.documentDetailId) {
        const auxObj = JSON.parse(JSON.stringify(obj));
        delete auxObj.documentDetailId;
        delete auxObj.children;
        delete auxObj.parentDetail;
        delete auxObj.changes;
        if (Object.keys(auxObj).length) {
          flatChanges.push({documentDetailId: obj.documentDetailId, ...auxObj});
        }
      }
      if (obj) {
        Object.keys(obj).forEach(key => {
          recursiveCheck(obj[key], innerGlobalComponent);
        })
      }
    }
  }
  recursiveCheck(changes);
  return flatChanges;
}

export function mergeChanges(obj1, changes) {
  changes.forEach((change, index) => {
    let auxFoundSubObject = findObjectByKeyValue(obj1, 'documentDetailId', change.documentDetailId);
    if (!auxFoundSubObject) {
      changes.splice(index, 1);
    } else {
      mergeObjects(auxFoundSubObject, change);
    }
  });
  return obj1;
}

function findObjectByKeyValue(obj, key, value) {
  if (obj.hasOwnProperty(key) && obj[key] === value) {
    return obj;
  }
  for (let k in obj) {
    if (typeof obj[k] === 'object' && obj[k] !== null) {
      const result = findObjectByKeyValue(obj[k], key, value);
      if (result) {
        return result;
      }
    }
  }
  return null;
}

export function mergeObjects(obj1, obj2, key, isInstanceContent = false, isInnerGlobal = false) {
  let instanceContent = isInstanceContent;
  let innerGlobal = isInnerGlobal;
  if (!instanceContent) {
    instanceContent = obj1?.properties?.type === 'instanceContent';
  }
  if (!innerGlobal) {
    innerGlobal = obj1?.properties?.type === 'global';
  }
  if (!isInstanceContent || isInnerGlobal) {
    if (obj1?.children && obj2?.children) {
      const auxChildren = [];
      const obj2Array = Object.values(obj2.children);
      if (typeof obj1.children === 'object' && Array.isArray(obj1.children) && obj1.children !== null) {
        obj1.children.forEach(chd => {
          const modifiedChild = obj2Array.find(modChd => modChd.documentDetailId === chd.documentDetailId);
          if (!modifiedChild) {
            auxChildren.push({documentDetailId: chd.documentDetailId});
          } else {
            auxChildren.push(modifiedChild)
          }
        })
      }
      obj2.children = auxChildren.reduce((acc, curr, index) => {
        acc[index] = curr;
        return acc;
      }, {});
    }
  }

  if (Array.isArray(obj1))
    obj1 = obj1.reduce((acc, currentValue, index) => {
      acc[index.toString()] = currentValue;
      return acc;
    }, {});
  if (Array.isArray(obj1))
    obj1 = obj1.reduce((acc, currentValue, index) => {
      acc[index.toString()] = currentValue;
      return acc;
    }, {});
  if (Array.isArray(obj2))
    obj2 = obj2.reduce((acc, currentValue, index) => {
      acc[index.toString()] = currentValue;
      return acc;
    }, {});
  for (const key of Object.keys(obj2)) {
    if (obj1[key] !== obj2[key]) {
      if (typeof obj2[key] === "object" && obj2[key] !== null) {
        obj1[key] = mergeObjects(obj1[key] || {}, obj2[key], key, instanceContent, innerGlobal);
      } else {
        obj1[key] = obj2[key];
      }
    }
  }
  if (obj1["0"] !== undefined) obj1 = Object.values(obj1);
  else if (JSON.stringify(obj1) === "{}") obj1 = [];
  return obj1;
}

export function findDifferences(newVal, oldVal, innerGlobalComponent = false) {
  let differences = {};
  if (newVal.documentDetailId) {
    differences.documentDetailId = newVal.documentDetailId
  }
  let insideGlobalComponent = innerGlobalComponent;
  if (!insideGlobalComponent) {
    insideGlobalComponent = newVal?.properties?.type === 'global';
  }

  if (newVal?.properties?.type === 'instanceContent' && !innerGlobalComponent) {
    return JSON.parse(JSON.stringify(newVal));
  } else {
    for (const key of Object.keys(newVal)) {
      if (!oldVal.hasOwnProperty(key)) {
        differences[key] = newVal[key];
      } else if (
        typeof newVal[key] === "object" &&
        typeof oldVal[key] === "object" &&
        newVal[key] !== null &&
        oldVal[key] !== null
      ) {
        const nestedDifferences = findDifferences(newVal[key], oldVal[key], insideGlobalComponent);
        if (Object.keys(nestedDifferences).length > 0) {
          differences[key] = nestedDifferences;
        }
      } else if (newVal[key] !== oldVal[key]) {
        differences[key] = newVal[key];
      }
    }
  }

  return differences;
}

export function nestedInputValuesToData(obj) {
  if (!obj) return {};
  const objKeys = Object.keys(obj);
  if (keysAreNumeric(objKeys)) {
    obj = Object.values(obj);
    for (let i = 0; i < obj.length; i++) {
      if (typeof obj[i] === "object") {
        obj[i] = nestedInputValuesToData(obj[i]);
      }
    }
  } else {
    for (let key in obj) {
      if (typeof obj[key] === "object") {
        obj[key] = nestedInputValuesToData(obj[key]);
      }
    }
  }
  return obj;
}

function keysAreNumeric(arr) {
  let isTrue = true;
  for (let item of arr) {
    if (!Number.isInteger(parseInt(item))) {
      isTrue = false;
      break;
    }
  }
  return isTrue;
}

export function dataToNestedInputValues(obj, keysToTransform, result) {
  const objIsArray = Array.isArray(obj);
  const objKeys = Object.keys(obj);
  if (objIsArray || keysAreNumeric(objKeys)) {
    if (!objIsArray) {
      obj = Object.values(obj);
    }
    for (let i = 0; i < obj.length; i++) {
      const elem = obj[i];
      if (elem && typeof elem === "object") {
        const keysFound = Object.keys(elem).filter((value) => keysToTransform.includes(value));
        if (keysFound.length === 1) {
          const idKey = keysFound[0];
          result[elem[idKey]] = elem;
          for (let key in elem) {
            if (elem[key] && typeof elem[key] === "object") {
              result[elem[idKey]][key] = dataToNestedInputValues(elem[key], keysToTransform, {});
            } else {
              result[elem[idKey]][key] = elem[key];
            }
          }
        }
      }
    }
  } else {
    for (let key in obj) {
      if (obj[key] && typeof obj[key] === "object") {
        dataToNestedInputValues(obj[key], keysToTransform, result);
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
}

async function waitForValidation(app) {
  return new Promise((res) => {
    const interval = setInterval(() => {
      if (!app.isGlobalValidating) {
        clearInterval(interval);
        res(true);
      }
    }, 50);
  });
}

export function clearIds(el, exceptKeys = []) {
  if (el.hasOwnProperty('_id') && !exceptKeys.includes('_id')) delete el._id;
  if (el.hasOwnProperty('documentDetailId') && !exceptKeys.includes('documentDetailId')) delete el.documentDetailId;
  if (el.children && el.children.length) {
    el.children.forEach(child => {
      clearIds(child, exceptKeys);
    });
  }
}
